export default {
    FAVORITE_LIST: 'favorite list',
};
